import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import axios from "axios";
import { SERVER_URL } from "../../../constants";

const ClientStats = () => {
  const [sponsors, setSponsors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const stats = [
    { value: "100+", description: "Satisfied Customers", icon: "🌍" },
    { value: "57%", description: "Best E-commerce Solution", icon: "📉" },
    { value: "4.2", description: "Customer Satisfaction Rating", icon: "⭐" },
  ];

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/api/sponsors`);
        const { data } = response.data;
        setSponsors(data);
      } catch (error) {
        console.error("Error fetching sponsors:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSponsors();
  }, []);

  const settings = {
    infinite: sponsors.length > 1,
    speed: 3000,
    slidesToShow: Math.min(sponsors.length, 5), // Show only as many slides as available
    slidesToScroll: 1,
    autoplay: sponsors.length > 1,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: Math.min(sponsors.length, 4),
          speed: 2500,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(sponsors.length, 3),
          speed: 2000,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(sponsors.length, 2),
          speed: 1500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(sponsors.length, 1),
          speed: 1000,
        },
      },
    ],
  };

  if (isLoading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="py-20 overflow-hidden relative">
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10"></div>
      <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16 relative"
        >
       <h2 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
  Trusted by Leading{" "}
  <span className="bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent">
    E-commerce Innovators
  </span>
</h2>
<p className="text-gray-600 text-lg max-w-2xl mx-auto">
  Supporting top e-commerce brands with cutting-edge solutions and trusted partnerships to elevate online retail experiences.
</p>

        </motion.div>

        {/* Logos Slider */}
        {sponsors.length > 0 ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="mb-20"
          >
            <div className="max-w-6xl mx-auto overflow-hidden">
              <Slider {...settings}>
                {sponsors.map((sponsor, index) => (
                  <motion.div
                    key={`${sponsor._id}-${index}`}
                    whileHover={{ scale: 1.05 }}
                    className="px-8 py-4 flex items-center justify-center h-32"
                  >
                    <div className="relative group">
                      <img
                        src={sponsor.logo}
                        alt={sponsor.name || `Partner ${index + 1}`}
                        className="max-h-20 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300 transform group-hover:scale-105"
                      />
                      <div className="absolute inset-0 rounded-lg bg-blue-500/0 group-hover:bg-blue-500/5 transition-colors duration-300"></div>
                    </div>
                  </motion.div>
                ))}
              </Slider>
            </div>
          </motion.div>
        ) : (
          <p className="text-center text-gray-500">No sponsors to display</p>
        )}

        {/* Stats Section */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center max-w-5xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="text-4xl mb-4">{stat.icon}</div>
              <h3 className="text-4xl font-extrabold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">
                {stat.value}
              </h3>
              <p className="text-gray-600">{stat.description}</p>
            </motion.div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default ClientStats;
